import classNames from 'classnames'
import React from "react"
import { Col, Container, Row } from "reactstrap"
import { Footer } from './components/Footer'
import { DisplayMode } from './containers/display/DisplayMode'
import { EditFightMode } from './containers/edit-fight/EditFightMode'
import { EditSetupMode } from './containers/edit-setup/EditSetupMode'
import { HeaderContainer } from './containers/HeaderContainer'
import { EditRosterMode } from './containers/roster/EditRosterMode'
import { DevTools } from './DevTools'
import { GistImport } from './GistImport'
import { ModalContainer } from "./modals/_ModalContainer"
import { RenderMode, useAppState } from "./redux/slices/app-slice"
import { assertAndCastBoolean, getQueryParamValue } from './utils/utils'

export const App: React.FC = () => {

    const appState = useAppState()

    const forceDevMode = assertAndCastBoolean(getQueryParamValue({
        query: window.location.search,
        paramName: "dev"
    }))

    return (
        <>
            <GistImport />

            <ModalContainer />

            {(process.env.NODE_ENV === 'development' || forceDevMode) && (
                <DevTools lite={process.env.NODE_ENV === 'production'} />
            )}

            <div className="d-flex flex-column w-100">
                {appState.outOfDateData &&
                    <div className={classNames(
                        "border-bottom bg-warning-striped p-2 px-3 font-weight-bold small"
                    )}>
                        {"Warning — Spell data is out of date and might be incorrect, new update will be released soon™"}
                    </div>
                }

                <Container fluid className="d-flex flex-grow-1 flex-column vh-100">

                    <Row className="flex-shink-0 border-bottom">
                        <Col>
                            <HeaderContainer />
                        </Col>
                    </Row>

                    <div
                        // Custom full-width div inside a bootstrap Container
                        className={classNames(
                            "d-flex",
                            // Needed to force down footer to bottom
                            "flex-grow-1"
                        )}
                        style={{
                            marginRight: "-15px",
                            marginLeft: "-15px"
                        }}
                    >

                        {appState.renderMode === RenderMode.Display &&
                            <DisplayMode />
                        }

                        {appState.renderMode === RenderMode.EditRoster &&
                            <EditRosterMode />
                        }

                        {appState.renderMode === RenderMode.EditFight &&
                            <EditFightMode />
                        }

                        {appState.renderMode === RenderMode.EditAssignments &&
                            <EditSetupMode />
                        }

                    </div>

                    <Footer />

                </Container>
            </div>
        </>
    )
}
